import React from 'react';
import MuseMarket from '../domains/muses/components/MuseMarket';

const MuseMarketPage: React.FC = () => {
  return <MuseMarket />;
};

export default MuseMarketPage; 